module.exports = __webpack_public_path__ + "resources/img/solution_finance_cloud3_v2.b03489213045301be5ea1f62efc89f3e.png";